import React from "react";
import "./loading.css";

function LoadingSpinner() {
  return (
    <div className="loading-spinner">
      <div className="spinner"></div>
    </div>
  );
}

export default LoadingSpinner;
